import { useEffect, useState, useRef, useContext } from "react";
// import { ApartmentViewContext } from "../context/ApartmentViewContext";
import styles from "../../../styles/aprt.module.scss";

function PlanRendererTreeDMode({ 
  svgContent, patternDefsIds,
  selectedCompartmentInd,
  hoveredCompartmentInd,
  setApartmentViewInteractions,
 }) {
  //TODO: temporary component? 3D Plan should be possible to render in other Modes, not as a separate MODE
  const [modifiedSvgContent, setModifiedSvgContent] = useState(svgContent);
const svgContainerRef = useRef(null);

// const { apartmentViewInteractions } = useContext(ApartmentViewContext);
// const { selectedCompartmentInd } = apartmentViewInteractions;

  useEffect(() => {
    if (!svgContent) return;

    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgContent, "image/svg+xml");
    const svgRoot = svgDoc.documentElement;
    const svgNS = "http://www.w3.org/2000/svg";

    const equipmentGroups = svgRoot.querySelectorAll(".equipments");
    const caseworksGroups = svgRoot.querySelectorAll(".caseworks");
    const tags = svgRoot.querySelectorAll(".tag");
    const stairwaysGroup = svgRoot.querySelectorAll(".stairways");
    const doorsGroup = svgRoot.querySelectorAll(".openings_door");
    const windowsGroup = svgRoot.querySelectorAll(".openings_window");
    const railings = svgRoot.querySelectorAll(".railings");
    const walls = svgRoot.querySelectorAll(".walls");
    const wallsPartition = svgRoot.querySelectorAll(".partition");
    const wallsShafts = svgRoot.querySelectorAll(".shaft");

    const elementsToHide = [
      ...equipmentGroups,
      ...caseworksGroups,
      ...tags,
      ...stairwaysGroup,
      ...doorsGroup,
      ...windowsGroup,
      ...railings,
      ...walls,
      // ...wallsPartition,
      // ...wallsShafts,
    ];
    elementsToHide.forEach((element) => {
      element.setAttribute("style", "display: none;");
    });

    const apartmentTier = svgRoot.querySelector(".apartment_tier");
    const underlayGroup = document.createElementNS(svgNS, "g");
    underlayGroup.setAttribute("data-layer", "underlay"); //TODO: do we need a class?
    const underlayRect = document.createElementNS(svgNS, "rect");
    underlayRect.setAttribute("stroke", "none");
    underlayRect.setAttribute("fill", `url(#${patternDefsIds[0]})`);
    underlayRect.setAttribute("width", "100%");
    underlayRect.setAttribute("height", "100%");

    underlayGroup.appendChild(underlayRect);
    apartmentTier.insertBefore(underlayGroup, apartmentTier.firstChild);

    const compartments = svgRoot.querySelectorAll(".compartments > g");

    const compartmentsGroup = svgRoot.querySelector('.compartments');
    const compartmentPaths =
    compartmentsGroup.querySelectorAll('.compartment');
    for (const path of compartmentPaths) {
        path.setAttribute("style", `fill:url(#${patternDefsIds[0]})`);
      }
    const serializer = new XMLSerializer();
    const newSvgContent = serializer.serializeToString(svgDoc);
    setModifiedSvgContent(newSvgContent);
  }, [svgContent]);

  const handleRoomHover = (ind, isOnPath) => {
    //TODO: move this to utils
    ind === null
      ? setApartmentViewInteractions(
          ({ isCompartmentPathHovered, hoveredCompartmentInd, ...rest }) => ({
            isCompartmentPathHovered: false,
            hoveredCompartmentInd: null,
            ...rest,
          })
        )
      : setApartmentViewInteractions(
          ({ isCompartmentPathHovered, hoveredCompartmentInd, ...rest }) => ({
            isCompartmentPathHovered: isOnPath,
            hoveredCompartmentInd: ind,
            ...rest,
          })
        );
  };
  const handleRoomClick = (ind) => {
    selectedCompartmentInd === ind //TODO: something is not always working here ?
      ? setApartmentViewInteractions(({ selectedCompartmentInd, ...rest }) => ({
          selectedCompartmentInd: null,
          ...rest,
        }))
      : setApartmentViewInteractions(({ selectedCompartmentInd, ...rest }) => ({
          selectedCompartmentInd: ind,
          ...rest,
        }));
  };
  useEffect(() => {
    const svgContainer = svgContainerRef.current;
    if (!svgContainer) return;

    const compartmentGroup = svgContainer.querySelector(".compartments");
    const compartmentPaths = compartmentGroup.querySelectorAll(".compartment");
    
    compartmentPaths.forEach((path) => {
      const compartmentNumber = Number(path.getAttribute("number"));
      //TODO: test listeners on mobile devices, maybe use onTouchStart instead of onClick
      path.addEventListener("click", () => handleRoomClick(compartmentNumber));
      path.addEventListener("mouseenter", () =>
        handleRoomHover(compartmentNumber, true)
      );
      path.addEventListener("mouseleave", () => handleRoomHover(null, false));
    });

    return () => {
      compartmentPaths.forEach((path) => {
        const compartmentNumber = Number(path.getAttribute("number"));
        path.removeEventListener("click", () => handleRoomClick(compartmentNumber));
        path.removeEventListener(
          "mouseenter",
          handleRoomHover(compartmentNumber, true)
        );
        path.removeEventListener("mouseleave", handleRoomHover(null, false));
      });
    };
  }, [modifiedSvgContent]);

  useEffect(() => {
    //TODO: check if not merge with above useEffect[svgContent]
    const svgContainer = svgContainerRef.current;
    if (!svgContainer) return;

    const compartmentGroup = svgContainer.querySelector(".compartments");
    const compartmentPaths = compartmentGroup.querySelectorAll(".compartment");

    compartmentPaths.forEach((path) => {
      const compartmentNumber = Number(path.getAttribute("number"));
      //TODO: test listeners on mobile devices, maybe use onTouchStart instead of onClick
      if (compartmentNumber === selectedCompartmentInd || compartmentNumber === hoveredCompartmentInd) {
        path.classList.add(`${styles.svg_path_highlighted_3d}`);
      }
      if (compartmentNumber != selectedCompartmentInd && compartmentNumber != hoveredCompartmentInd) {
        path.classList.remove(`${styles.svg_path_highlighted_3d}`);
      }
    });

  }, [selectedCompartmentInd, hoveredCompartmentInd]);

  return (
    <div
      ref={svgContainerRef}
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      dangerouslySetInnerHTML={{ __html: modifiedSvgContent }}
    />
  );
}

export default PlanRendererTreeDMode;
